(function () {
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'CODE', 'PRE']);
  const TEXT_ATTRIBUTES = ['aria-label', 'alt', 'title'];
  const MTP_PATTERN = /(^|[^A-Za-z0-9_])MTP(?!®)(?!-\d)(?=$|[^A-Za-z0-9_])/g;
  const CELSIUS_PATTERN = /(^|[^A-Za-z0-9_])([+-]?\d+(?:\.\d+)?)\s*(?:°\s*)?C\b/g;

  function normalizeText(value) {
    if (!value || typeof value !== 'string') return value;

    return value
      .replace(MTP_PATTERN, '$1MTP®')
      .replace(CELSIUS_PATTERN, '$1$2℃');
  }

  function shouldSkipElement(element) {
    return !element || SKIP_TAGS.has(element.tagName) || element.closest('[contenteditable="true"], [data-huawell-normalizer-ignore]');
  }

  function normalizeTextNode(node) {
    if (!node || !node.nodeValue || shouldSkipElement(node.parentElement)) return;

    const normalized = normalizeText(node.nodeValue);
    if (normalized !== node.nodeValue) node.nodeValue = normalized;
  }

  function normalizeAttributes(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE || shouldSkipElement(element)) return;

    TEXT_ATTRIBUTES.forEach((attribute) => {
      if (!element.hasAttribute(attribute)) return;

      const currentValue = element.getAttribute(attribute);
      const normalizedValue = normalizeText(currentValue);
      if (normalizedValue !== currentValue) element.setAttribute(attribute, normalizedValue);
    });
  }

  function normalizeMeta() {
    document.title = normalizeText(document.title);

    document
      .querySelectorAll('meta[name="description"], meta[property^="og:"], meta[name^="twitter:"]')
      .forEach((meta) => {
        const content = meta.getAttribute('content');
        const normalized = normalizeText(content);
        if (normalized !== content) meta.setAttribute('content', normalized);
      });
  }

  function runInsertedScripts(container) {
    container.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attribute) => {
        script.setAttribute(attribute.name, attribute.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }

  function refreshCableEstimatorIfStale() {
    if (!/^\/(?:[a-z]{2}\/)?pages\/cable-estimator\/?$/i.test(window.location.pathname)) return;

    const root = document.querySelector('[data-cable-estimator]');
    if (!root || root.querySelector('[data-field="jacket"]')) return;

    const sectionWrapper = root.closest('.shopify-section[id^="shopify-section-"]');
    const sectionId = sectionWrapper && sectionWrapper.id.replace(/^shopify-section-/, '');
    if (!sectionWrapper || !sectionId) return;

    const sectionUrl = new URL(window.location.pathname, window.location.origin);
    sectionUrl.searchParams.set('section_id', sectionId);
    sectionUrl.searchParams.set('_hwce_refresh', 'ofnp-jacket');

    fetch(sectionUrl.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html || !html.includes('data-field="jacket"')) return;
        sectionWrapper.innerHTML = html;
        runInsertedScripts(sectionWrapper);
        normalizeRoot(sectionWrapper);
      })
      .catch(() => {});
  }

  function normalizeRoot(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root);
      return;
    }

    if (
      root.nodeType !== Node.ELEMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE
    ) {
      return;
    }

    if (root.nodeType === Node.ELEMENT_NODE) {
      if (shouldSkipElement(root)) return;
      normalizeAttributes(root);
    }

    const treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return shouldSkipElement(node.parentElement) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      },
    });

    let textNode = treeWalker.nextNode();
    while (textNode) {
      normalizeTextNode(textNode);
      textNode = treeWalker.nextNode();
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(TEXT_ATTRIBUTES.map((attribute) => `[${attribute}]`).join(',')).forEach(normalizeAttributes);
    }
  }

  const pendingRoots = new Set();
  let scheduled = false;

  function scheduleNormalize(root) {
    if (!root) return;
    pendingRoots.add(root);

    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      const roots = Array.from(pendingRoots);
      pendingRoots.clear();
      roots.forEach(normalizeRoot);
      normalizeMeta();
    });
  }

  function start() {
    normalizeRoot(document.body);
    normalizeMeta();
    refreshCableEstimatorIfStale();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          scheduleNormalize(mutation.target);
          return;
        }

        if (mutation.type === 'attributes') {
          scheduleNormalize(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(scheduleNormalize);
      });
    });

    observer.observe(document.documentElement, {
      attributeFilter: TEXT_ATTRIBUTES,
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
